import React from 'react';
import Img from '../../../../../../components/Img';
import { WIDGET_LAYOUT_TYPE, WIDGET_TYPE } from '../../../../../../constants/service/app/widgetConstants';
import './WidgetPreviewStoreItem.scss';

const WidgetPreviewStoreItem = (props) => {
  const { layoutType, storeItem } = props;
  const { url, title, contents } = storeItem;

  return (
    <div className="widget-store-item">
      {
        /**
         *  위젯 브랜드 레이아웃 타입이 스와이프가 아닌 경우에만
         *  이미지가 노출될 수 있음
         */
        layoutType !== WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BRAND].SWIPE ? (
          <div className="img-wrap">
            <Img clickAble={false} src={url} />
          </div>
        ) : null
      }

      <div className="title">
        {title ? title : <span className="require-info">위젯 브랜드 아이템 타이틀을 설정해주세요.</span>}
      </div>

      {
        /**
         *  위젯 브랜드 레이아웃 타입이 그리드 1 x 4 가 아닌 경우에만
         *  내용이 노출될 수 있음
         */
        layoutType !== WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BRAND].GRID_1_X_4 ? (
          <div className="contents">{contents}</div>
        ) : null
      }
    </div>
  );
};

export default WidgetPreviewStoreItem;
